import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme: Theme) => ({
  paper: {
    width: "35vw",
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      height: "70vh",
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 8,
    fontSize: 20,
    lineHeight: "28px",
    color: "#344054",
    fontWeight: "bold",
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    paddingTop: "1rem",
    width: "100%",
  },
  searchButton: {
    color: "#fff",
    background: "#308CDB",
    borderRadius: 8,
    padding: "12px 20px",
    boxShadow: "none",
    "&:hover": {
      color: "#fff",
      background: "#308CDB",
    },
  },
  modalFooter: {
    background: "#F7F7F9",
    height: 80,
    borderRadius: "0 0 8px 8px",
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  modalFooterCancel: {
    background: "transparent",
    color: "#F97066",
    borderRadius: 8,
    boxShadow: "none",
    marginRight: 8,
    "&:hover": {
      background: "transparent",
      color: "#F97066",
    },
  },
  modalFooterAssign: {
    background: "#32D583",
    color: "#fff",
    borderRadius: 8,
    boxShadow: "none",
    "&:hover": {
      background: "#32D583",
      color: "#fff",
    },
  },
  modalRevokeButton: {
    height: 32,
  },
  modalBodyTitle: {
    color: "#465869",
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  modalCheckboxLabel: {
    "& span:nth-child(2)": {
      color: "#465869",
      fontSize: 14,
      lineHeight: "24px",
      fontWeight: 500,
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  loadingComponent: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#4658691c",
    zIndex: 99,
    width: "100%",
    height: "100%",
  },
  notFoundMessage: {
    color: "#F79009",
    margin: 0,
    fontWeight: 600,
    fontFamily: `'Manrope', sans-serif'`,
  },
}));

export default styles;
